export default "__VITE_ASSET__CSW_DSU8__"